/**
 * @file Throwable error with numeric error code and optional params.
 *
 * @copyright 2015-2023 Tinode LLC.
 */
'use strict';

export default class CommError extends Error {
  constructor(message, code, params) {
    super(`${message} (${code})`);
    this.name = 'CommError';
    this.code = code;
    this.params = params;
  }
}
